
import { Fragment } from "react/cjs/react.production.min";
import prettyFloat from "../../../scripts/helpers/pretty.float";
import { ReactComponent as TrashIcon } from "./icons/trash.svg";
import { CoT_MODE, DEAL_PRICE_WATCH_MODE, DEAL_TYPES } from "../../../settings/constants";
import twoDigitFormat from "../../../scripts/helpers/two.digit.format";

const Movement = ( props ) => {

  const {

    id,
    type,
    amount,
    currency,
    price,
    commission,
    date,
    actionRemove,
    price_watch_mode,
    comission_or_time,
    actialAmountOfDeal,
    dealType,
    setAmount = () => {},
    setPrice = () => {}

  } = props;

  const TYPE_NAME = {

    1: <Fragment><div className = "desktop">Покупка</div><div className = "mobile">BUY</div></Fragment>,
    2: <Fragment><div className = "desktop">Продажа</div><div className = "mobile">SELL</div></Fragment>,

  }

  const PRICE = {

    [ DEAL_PRICE_WATCH_MODE.PRICE_OF_DEAL ]: price,
    [ DEAL_PRICE_WATCH_MODE.PRICE_OF_ONE_PAPER ]: price / amount,

  }

  let timestamp = date;

  if ( typeof timestamp === "string" ) { timestamp = new Date( date ); }

  const time = `${ twoDigitFormat( timestamp.getHours() ) }:${ twoDigitFormat( timestamp.getMinutes() ) }`;

  function handleRemove() {

    if ( 
      
      ( 
        ( dealType === DEAL_TYPES.LONG && type === DEAL_TYPES.LONG )
        ||
        ( dealType === DEAL_TYPES.SHORT && type === DEAL_TYPES.SHORT )
      )
      &&
      actialAmountOfDeal - amount < 0 

    ) {

      const errorText = `Нельзя остаться в отрицательном количестве ` 
        + `торгуемого инструмента! Попробуйте удалить сначала `
        + `${ dealType === DEAL_TYPES.LONG ? `продажи` : `выкупы` }.`

      alert( errorText ); 
      
      return; 

    }

    actionRemove( id );

  }
  
  return (

    <div className = "transaction_element relative flex">

      <div 
        title = "Удалить движение внутри сделки"
        className = "transaction_element__remove absolute flex justify-center items-center"
        onClick = { handleRemove }
      >
        <TrashIcon />
      </div>

      <div className = "text flex-1">

        { TYPE_NAME[ type ] }

      </div>

      <div 
      
        className = "text quantity transaction_col2 text-center"
        onClick = { () => setAmount( amount ) }
        
      >

        { amount }

      </div>

      <div 
      
        className = "text price transaction_col3 text-right"        
        onClick = { () => setPrice( prettyFloat( PRICE[ price_watch_mode ] ) ) }
        
      >

        { prettyFloat( PRICE[ price_watch_mode ] ) } { currency }

      </div>

      <div className = "text commission transaction_col4 text-right">
        
        { comission_or_time === CoT_MODE.COMISSION

          ? <Fragment>{ commission } { currency }</Fragment>
          : time

        }        

      </div>
        
    </div>

  );

}

export default Movement;